import { render, staticRenderFns } from "./DayPicker.vue?vue&type=template&id=35c54d0c&scoped=true&"
import script from "./DayPicker.vue?vue&type=script&lang=js&"
export * from "./DayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c54d0c",
  null
  
)

export default component.exports